import { render, staticRenderFns } from "./Gopages.vue?vue&type=template&id=12644c15&scoped=true"
import script from "./Gopages.vue?vue&type=script&lang=js"
export * from "./Gopages.vue?vue&type=script&lang=js"
import style0 from "./Gopages.vue?vue&type=style&index=0&id=12644c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12644c15",
  null
  
)

export default component.exports